<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { Payment } from '../../../../Types/invoice'
import { usePayment } from '../../../../Composables/Invoice/usePayment.ts'

const props = defineProps<{
  payment: Payment
}>()

const { n, t } = useI18n()
const { hasRejectedReason } = usePayment(props.payment)
</script>

<template>
  <tr>
    <td>{{ payment.paymentMean ? payment.paymentMean.name : '-' }}</td>
    <td>{{ payment.dueAt ? $d(new Date(payment.dueAt), 'date') : '-' }}</td>
    <td>{{ t('invoice.status.' + payment.status + '.label') }}</td>
    <td>{{ payment.paidAt ? $d(new Date(payment.paidAt), 'date') : '-' }}</td>
    <td>
      <template v-if="payment.rejectedAt">
        {{ $d(new Date(payment.rejectedAt), 'date') }}
        <template v-if="hasRejectedReason">
          <br />
          {{ payment.rejectMotif }}
          <i class="fa fa-info-circle" :title="t('payment.reject.code.' + payment.rejectMotif)"></i>
        </template>
      </template>
      <template v-else-if="payment.canceledAt">{{ $d(new Date(payment.canceledAt), 'date') }}</template>
      <template v-else>-</template>
    </td>
    <td>{{ n(Number(payment.refund ? -payment.amount : payment.amount), 'currency') }}</td>
  </tr>
</template>
